<template>
  <div class="pt-5 d-flex align-items-center justify-content-center vh-100">
    <div class="p-4 text-center">
      <img :src="`/img/svg/Logo_Grupo_Mass.svg`" alt="Logo de la empresa" class="img-fluid">
      <h2 class="text-white mt-4">ERROR 404</h2>
      <h4 class="text-white">Pagina no encontrada</h4>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'

  export default {
    name: 'HomeView',
    setup() {
      return {
        // urlBase,
      };
    },
  };
</script>

